
  export default {
    name: 'BankAddEmptyCard',
    props: {
      bankAccount: {
        type: Object,
        default: null
      },
      selectedBankId: {
        type: String,
        default: null
      },
      showDisableAccount: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      bankAccount(value) {
        if (value?.player_bank_accounts?.length > 0) {
          this.setDefaultToCard(value)
        }
      }
    },
    mounted() {
      if (this.bankAccount?.player_bank_accounts?.length > 0) {
        this.setDefaultToCard(this.bankAccount)
      }
    },
    methods: {
      selectedBankAccount(id, toggle) {
        this.$emit('onSelectedBankAccount', id, toggle)
      },
      navigate() {
        this.$router.push('/payment-methods')
      },
      setDefaultToCard(bankAccount) {
        const accounts = bankAccount?.player_bank_accounts

        const primaryAccount = accounts?.find(account => account.is_primary === true)

        if (this.showDisableAccount && !primaryAccount?.bank_id) {
          if (accounts.length > 1) {
            this.selectedBankAccount(accounts[1]?.id)
          } else {
            this.selectedBankAccount('')
          }
        } else {
          this.selectedBankAccount(primaryAccount?.id)
        }
      }
    }
  }
